<template>
  <div class="row">
    <!-- START Page heading -->
    <div class="columns small-12">
      <h3>{{ $t("services") }}</h3>
      <div class="flex">
        <div class="w-full">
          <input
            v-model="search"
            class="form-control mb-3"
            :placeholder="$t('search')"
            @input="handleSearch"
          />
        </div>

        <div class="whitespace-nowrap mt-2 ml-2">
          <p>
            <strong>{{ filteredServices.length }}</strong> {{ $t("results") }}
          </p>
        </div>
      </div>

      <div>
        <table-columns-filter
          class="mb-2"
          :columns="fields"
          :rows="unfilteredServices"
          @input="updateSelectedFilters"
        />
      </div>

      <b-table
        :items="filteredServices"
        responsive
        :fields="fields"
        :sort-by.sync="sortBy"
        striped
      />
    </div>
  </div>
</template>

<script>
import {getServices} from "@/services/customer/getServices";
import {getServicePackageStatus} from "@/functions/services/getServicePackageStatus";
import TableColumnsFilter from "@/components/table/TableColumnsFilter.vue";
import {formatDate} from "@/functions/formatting/formatDate";

export default {
  name: "ShopAccountServices",
  components: {TableColumnsFilter},
  data() {
    return {
      services: [],
      show: false,
      selectedFilters: {},
      filteredServices: [],
      unfilteredServices: [],
      fields: [
        {
          key: "orderID",
          label: this.$t("order"),
          sortable: false,
        },
        {
          key: "itemDescription",
          label: this.$t("item"),
          sortable: false,
        },
        {
          key: "person",
          label: this.$t("person2"),
          sortable: false,
          filterable: true,
        },
        {
          key: "department",
          label: this.$t("Department"),
          sortable: false,
        },
        {
          key: "status",
          label: this.$t("status"),
          sortable: false,
          filterable: true,
        },
        {
          key: "dateTimeCreated",
          label: this.$t("Created on"),
          sortable: false,
        },
        // {
        //   key: "dateTimeExecuted",
        //   label: this.$t("Executed on"),
        //   sortable: false,
        //   formatter: this.formatDate,
        // },
        {
          key: "dateTimeLastExecuted",
          label: this.$t("Last executed on"),
          sortable: false,
          formatter: this.formatDateTimeLastExecuted,
        },
        {
          key: "notExecuted",
          label: this.$t("Not executed"),
          sortable: false,
        },
        {
          key: "executed",
          label: this.$t("Executed"),
          sortable: false,
        },
      ],
      search: "",
      customerId: null,
    };
  },
  computed: {
    parentPackages() {
      return this.dateSortedPackages.filter(
        (service) => service.parent === true,
      );
    },
    childServices() {
      return this.dateSortedPackages.filter(
        (service) => service.parent === false,
      );
    },

    dateSortedPackages() {
      const services = this.services;
      return services.sort((a, b) => {
        return new Date(b.dateTimeCreated) - new Date(a.dateTimeCreated);
      });
    },
  },
  async created() {
    this.customerId = document.getElementById("customerid").value;
    this.$store.commit("setCustomerID", {
      customerID: this.customerId,
    });
    this.services = await getServices({customerId: this.customerId});
    this.updateServices();
  },
  methods: {
    handleSearch() {
      this.updateServices();
    },
    updateServices() {
      const search = this.search.trim();
      console.log(search);
      const orderedPackages = this.getOrderedPackages();
      this.unfilteredServices = orderedPackages;

      //if (!search) return orderedPackages
      const columnFilteredPackages = orderedPackages.filter((packageObject) => {
        return Object.keys(this.selectedFilters).every((key) => {
          return this.selectedFilters[key].includes(packageObject[key]);
        });
      });

      const formattedDateServices = columnFilteredPackages.map((service) =>
        this.formatServiceDate(service),
      );

      this.filteredServices = formattedDateServices.filter((service) => {
        return [
          service.orderID,
          service.itemDescription,
          service.person,
          service.department,
          service.status,
          service.dateTimeCreated,
          service.dateTimeExecuted,
          service.dateTimeLastExecuted,
        ].find((x) => x?.toLowerCase().includes(search.toLowerCase()));
      });
    },
    formatServiceDate(service) {
      return {
        ...service,
        dateTimeCreated: formatDate({date: service.dateTimeCreated}),
        dateTimeExecuted: formatDate({date: service.dateTimeExecuted}),
        dateTimeLastExecuted: formatDate({date: service.dateTimeLastExecuted}),
      };
    },
    getOrderedPackages() {
      const packages = [];
      for (const parentService of this.parentPackages) {
        const services = this.getChildServicesFromParentService(parentService);

        const executedCount = services.filter(
          (service) => service.status === "Executed",
        ).length;

        const notExecutedCount = services.filter(
          (service) => service.status !== "Executed",
        ).length;

        let statusKey = getServicePackageStatus({
          executedCount,
          notExecutedCount,
        });

        const status = this.$t(statusKey);
        const dateTimeLastExecuted = parentService.dateTimeExecuted;

        packages.push({
          ...parentService,
          status,
          executed: executedCount,
          notExecuted: notExecutedCount,
          dateTimeLastExecuted,
        });
      }
      return packages;
    },
    updateSelectedFilters(selectedFilters) {
      this.selectedFilters = selectedFilters;
      this.updateServices();
    },
    getChildServicesFromParentService(parentService) {
      return this.childServices.filter(
        (childService) =>
          childService.parentOrderItemID === parentService.orderItemID &&
          childService.orderID === parentService.orderID,
      );
    },
    formatDateTimeLastExecuted(date, value, row) {
      if (row.status === "Executed") {
        return this.$t("N/A");
      }
      return date;
    },
  },
};
</script>

<style>
.progress__bubble {
  height: 15px !important;
  width: 15px !important;
  border: 1px solid white !important;
  border-radius: 0% !important;
}
</style>
